// extracted by mini-css-extract-plugin
module.exports = {"customer-welcome__image":"Login_customer-welcome__image___8_Nz","inner-image":"Login_inner-image__5T7Zn","form__subscribe-to-marketing":"Login_form__subscribe-to-marketing__KwEpn"};